import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ProfileSetup.SsoPage', {
    pageTitle: 'Profile Setup',
    errorSignup: 'Oops, something went wrong. Please try again.',
});
